/**
 * Logger conditionnel pour Konstellation
 * Désactive les logs en production pour améliorer les performances
 */

interface Logger {
  log: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
}

const isProd = typeof process !== 'undefined' 
  ? process.env.NODE_ENV === 'production'
  : typeof import.meta !== 'undefined' && (import.meta as any).env?.PROD;

// Noop function for production
const noop = () => {};

/**
 * Logger qui désactive les logs en production
 * Garde console.error actif pour les erreurs critiques
 */
export const logger: Logger = {
  log: isProd ? noop : console.log.bind(console),
  info: isProd ? noop : console.info.bind(console),
  warn: isProd ? noop : console.warn.bind(console),
  error: console.error.bind(console), // Toujours actif pour les erreurs
  debug: isProd ? noop : console.debug.bind(console),
};

/**
 * Logger pour les fonctions Cloudflare Workers
 * Utilise le contexte d'exécution pour déterminer l'environnement
 */
export const createWorkerLogger = (env?: { ENVIRONMENT?: string }) => {
  const isProduction = env?.ENVIRONMENT === 'production';
  
  return {
    log: isProduction ? noop : console.log.bind(console),
    info: isProduction ? noop : console.info.bind(console),
    warn: isProduction ? noop : console.warn.bind(console),
    error: console.error.bind(console),
    debug: isProduction ? noop : console.debug.bind(console),
  };
};

export default logger;
